import $ from 'jquery';
export const ENDPOINTS = {
    PAGE_TERMS_OF_USE: 'page_terms_of_use',
    STRUCTURED_COMPETITION: 'create_structured_competition/',
    CONFIRM_OCCUPATION: 'confirm_occupation/',
    QUOTATION_STRUCTURED_QUESTION: 'quotation_structured_question/',
    CREATE_STRUCTERED_COMPETITION: 'create_structured_competition/',
    SUPPLIER_PROFILE_NETWORK: 'supplier_profile_network/',
    HAS_OCCUPATION: 'has_occupation/',
    OFFERS_OPPORTYNITY: 'offers_opportunity/',
    NOTIFICATION_HAS_NEW: 'notifications/has_new/',
    NOTIFICATION_READ: 'notifications/make_read/',
    UNSUBSCRIBE: 'unsubscribe/',
    BLACKLIST_EMAIL: 'blacklist_email/',
    CREATE_OCCUPATION: 'create_occupation/',
    EXPORT_TAGS_METRICS: 'export_metrics_tags/',
    SUPPLIER_SIGNUP_COMPLEMENT: 'signup_complement/',
    EXPORT_LEADS: 'export_leads/',
    EXPORT_SUPPLIERS_LEADS: 'export_suppliers_leads/',
    SUPPLIER_HIDDEN_QUOTATIONS: 'supplier_hidden_quotations/',
    CREATE_SUPPLIER_HIDDEN_QUOTATIONS: 'create_supplier_hidden_quotations/',
    SALES_AUTOMATION_MY_PAGE_ACCESS_LOG: 'sales_automation_my_page_access_log/',
    SUBSCRIPTION_CONTACT_NETWORK: 'subscription_contact_network/',
    SUBSCRIPTION_OVERVIEW: 'subscription_overview/',
    CREATE_ONLINE_MARKETING_INVESTMENT_REQUEST: 'online_marketing_investment/',
    SUBSCRIPTION_CHECK: 'subscription_check/',
    REQUEST_PUBLIC_DOCUMENTS: 'request_public_documents/',
    EXPORT_SUPPLIER_ACQUIRED_CONTACTS: 'operator_export_acquired_contacts/',
    RETRIEVE_ADQUIRED_CONTACT: 'retrieve_acquired_contact/',
    REGISTER_BPO_TERMS_OF_AGREEMENTS_CLICK: 'bpo_terms_access_log/',
    PUBLIC_DOCUMENT_ACCESS_LOG: 'public_document_access_log/',
    IMPORT_DOCUMENT_CSV: 'import_documents/',
    CONTRACTOR_PUBLIC_DOCUMENTS: 'contractor_public_documents/',
    PUBLIC_DOCUMENTS: 'public_documents/',
    SUPPLIER_PUBLIC_DOCUMENTS: 'supplier_public_documents/',
    LIST_SUBSCRIBERS: 'list_subscribers/',
    LIST_SUPPLIERS: 'list_suppliers/',
    ACCEPT_PAY_FOR_COMPETITION: 'accept_pay_for_competition/',
    ACTIVITIES: 'activities/',
    ACTIVITIES_QUESTIONS: 'questions/',
    ACTIVITY_MANAGER: 'activity_manager/',
    ACTIVITY_PANEL: 'activity_panel/',
    ADD_COMPETITION_TO_DASHBOARD: 'offers/',
    ADD_LEAD_PRICES: 'add_lead_prices/',
    ADMIN_CLOSED_COMPETITIONS: 'admin_list_closed_competitions/',
    ADMIN_LIST_CONTRACTORS: 'admin_list_contractors/',
    ADMIN_LIST_INVITATIONS: 'admin_list_invitations/',
    ADMIN_LIST_QUOTATIONS: 'admin_list_quotations/',
    ADMIN_LIST_SUPPLIERS: 'admin_list_suppliers/',
    ADMIN_OPEN_COMPETITIONS: 'admin_list_open_competitions/',
    ADMINISTRATOR_QUOTATIONS_REQUESTS: 'administrator_list_quotation_requests/',
    ADQUIRE_CONTACT: 'acquire/',
    ADQUIRE_MULTIPLE_CONTACTS: 'acquire_public/',
    ADQUIRED_CONTACTS: 'acquired_contacts/',
    ADWORDS_ALERT: 'notifications/',
    ADWORDS_QUOTATION: 'anonymous/',
    ADWORDS_USER: 'create_random_pass_user/',
    ANONYMOUS_OFFERS: 'anonymous_offers/',
    ASSOCIATE_PROPOSAL: 'associate_proposal/',
    AUTOCOMPLETE_INVITES: 'autocomplete_invites/',
    BANNER_TEXTS: 'banner_texts/',
    CHANGE_INVITATION_INFO: 'change_invitation_info/',
    CHANGE_INVITE_EMAIL: 'change_invite_email/',
    CHANGE_INVITE_STATUS: 'change_invite_status/',
    CHANGE_PASSWORD: 'password/change/',
    CHECK_EMAIL_EXISTENCE: 'is_email_in_use/',
    CHECK_IF_IS_SUBSCRIBER: 'is_subscriber/',
    CHECK_IF_SUPPLIER_IS_PARTICIPATING: 'is_supplier_participating/',
    CHECKOUT_NOTIFICATION: 'checkout_notification/',
    CLICK_ANALYTICS: 'click_analytics/',
    CLOSE_COMPETITION_SUBMISSIONS: 'close_competition_submissions/',
    COMPETITION_ACTIVITY: 'quotation_activity/',
    COMPETITION_WINNER: 'competition_winner/',
    COMPETITION_WITH_TOKEN: 'competition_with_token/',
    COMPETITIONS: 'competitions/',
    CONDOMINUMS: 'contractors/',
    CONDOTECH_LIST_PARTNERS: 'partners/',
    CONDOTECH_NOTIFICATION: 'condotech_notification/',
    CONDOTECHS_DETAILS: 'condotechs_details/',
    CONFIRM_MEETING: 'accept_meeting/',
    CONTACT_NETWORK_CATEGORIES: '',
    CONTACT_NETWORK_LIST: 'list_contacts/',
    CONTACT_NETWORK_LIST_CITIES: 'list_cities/',
    CONTACT_NETWORK_LIST_NEIGHBORHOODS: 'list_neighborhoods',
    CONTACT_TYPES: 'types/',
    CONTACT_US: 'contact_us/',
    CONTACTS_PRICES: 'contacts_prices/',
    CONTRACTOR_CONTACT: 'contractor_contact/',
    CONTRACTOR_FIRST_ACCESS: 'contractor/first_access/',
    CONTRACTOR_LAST_FEEDBACK_SEEN: 'contractor_feedback_last_seen/',
    CONTRACTOR_LIST_COMPETITION_REQUESTS: 'quotation_request/',
    CONTRACTOR_LIST_COMPETITIONS: 'competitions/',
    CONTRACTOR_SIGNUP: 'contractor/signup/',
    CONTRACTOR_WITH_TOKEN: 'contractor_with_token/',
    CONTRACTORS: 'contractors/',
    COST_CENTERS: 'cost_centers/',
    CREATE_COMPETITION: 'competitions/',
    CREATE_CONDOMINUM_QUOTATION: 'complete_survey/',
    CONFIRM_ENTERPRISE: 'confirm_opportunity_enterprise/',
    CREATE_PAGSEGURO_BALANCE_CHECKOUT: 'balancepurchase_checkout/',
    CREATE_PAGSEGURO_CHECKOUT_LOG: 'checkout_log/',
    CREATE_PAGSEGURO_CONTACT_CHECKOUT: 'contact_checkout/',
    CREATE_PAGSEGURO_LEAD_CHECKOUT: 'leadpurchase_checkout/',
    CREATE_PAGSEGURO_MEETING_CHECKOUT: 'meeting_checkout/',
    CREATE_PAGSEGURO_SUBSCRIPTION_CHECKOUT: 'subscription_checkout/',
    CREATE_PROPOSAL_XLS: 'create_xls_proposal/',
    CREATE_PROPOSALS_XLS_FOR_COMPETITION: 'create_xls_proposals_for_competition/',
    CREATE_PROPOSAL: 'create_proposal/',
    CROSS_SELLER: 'cross_seller/',
    EXPORT_QUOTATIONS_PDF: 'contractors/export-quotation-pdf/',
    ANONYMOUS_OFFER: 'anonymous_offer/',
    DASHBOARD_ELIGIBLE_COMPETITIONS: 'eligible_dashboard_competitions/',
    DECLINE_PAY_FOR_COMPETITION: 'decline_pay_for_competition/',
    DOWNLOAD_COMERCIAL_PROPOSAL: 'download_comercial_proposal/',
    DOWNLOAD_COMPETITION_MAP: 'download_competition_map/',
    DOWNLOAD_MASS_INVITATION_CSV: 'export_filtered_invites/',
    DRAFTS: 'drafts/',
    EDIT_COMPETITION: 'update_competition/',
    ENABLE_CONTRACTOR: 'enable_contractor/',
    ENTERPRISE_OFFERS: 'offers_enterprise/',
    ENGELINK_INVITE_SUPPLIERS: 'engelink_invite_suppliers/',
    ENTER_GOD_MODE: 'enter_god_mode/',
    EXPORT_ACQUIRED_CONTACTS: 'export_acquired_contacts/',
    EXPORT_ADS_NOTIFICATIONS_DATA: 'export_notifications/',
    EXPORT_ALL_INVITES: 'export_all_invites/',
    EXPORT_ALL_TAGS: 'export_all_tags/',
    EXPORT_CALCULATOR_DATA: 'export_calculator_data',
    EXPORT_CALL_LOG: 'download_report/',
    EXPORT_CONDO_BLUE_DATA: 'export_condo_blue_data',
    EXPORT_CONTRACTORS: 'export/',
    EXPORT_CS_DATA: 'export_customer_success/',
    EXPORT_INVITES: 'export_invites/',
    EXPORT_NETWORK_CONTACTS: 'export_contacts/',
    EXPORT_NPS_DATA: 'export_surveys_responses/',
    EXPORT_OCCUPATIONS_BY_TAG: 'export_occupations_by_tag/',
    EXPORT_PARTNER_CONTRACTORS: 'export_partner_competitions/',
    EXPORT_PARTNER_SUPPLIERS: 'export_partner_suppliers/',
    EXPORT_QUOTATIONS_DATA: 'export/',
    EXPORT_QUOTATIONS_FEEDBACKS: 'export_competition_feedbacks/',
    EXPORT_QUOTATIONS_SOURCES_DATA: 'export_quotations_sources/',
    EXPORT_RD_STATION_DATA: 'export_all_users/',
    EXPORT_SUBSCRIBERS_DATA: 'subscription_metrics/',
    EXPORT_SUPPLIERS: 'export_suppliers/',
    FILTER_INVITES: 'filter_invites/',
    FINISH_COMPETITION: 'finish_competition/',
    NOTIFICATION_NEW_QUOTATION: 'quotation_fillin_alert/',
    GET_ADMINISTRATOR_PAGE_DATA: '/',
    GET_AMOUNTS: 'amounts/',
    GET_BUDGETS: 'budgets/',
    GET_CONTRACTOR_PARTNER: 'contractor_partner',
    GET_FEEDBACK_ELIGIBILITY: 'feedback_eligibility/',
    GET_LOCATION_PHONE: 'get_location_phone/',
    GET_OBJECTIVES: 'competition_objectives/',
    GET_PRO_SUBSCRIBERS_FROM_TAG: 'meeting_ready_suppliers_by_quotation/',
    GET_SUPPLIER_DISCOUNT: 'supplier_discount/',
    GET_TOP_CONTACTS: 'top_contacts_list/',
    GET_TOTAL_OF_SENT_PROPOSALS_BY_SUPPLIER: 'get_total_of_sent_proposals_by_supplier/',
    GET_TOTAL_OF_SENT_PROPOSALS_IN_COMPETITION: 'get_total_of_sent_proposals_in_competition/',
    GROUPS: 'groups/',
    HAVERSINE_FORMULA_RESULTS: 'haversine_formula_results/',
    IMPORT_INVITES: 'import_invites/',
    IMPORT_SUPPLIER_TAGS: 'import_supplier_tags/',
    INVITATION_ADDITIONAL_INFO: 'admin_invitation_additional_info/',
    INVITATION_DETAILS: 'invite_data/',
    INVITE_ADDITIONAL_SUPPLIERS: 'invite_additional_suppliers/',
    INVITE_SUPPLIERS: 'invite_suppliers/',
    LANDING_PAGE_DATA: 'landing_page/',
    LEAD_HISTORY: 'lead_payment/',
    LEAD_PAYMENTS: 'lead_payments/',
    LEAD_WITH_TOKEN: 'lead_with_token/',
    LIST_BALANCE_PACKAGES: 'balance-purchases/',
    LIST_IMPORTED_INVITES: 'list_imported_invites/',
    LIST_MEETING_READY_SUPPLIERS: 'meeting_ready_suppliers/',
    LOGIN: 'login/',
    LOGOUT: 'logout/',
    MEETINGS: 'meetings/',
    NETWORK_CONTACTS: 'contacts/',
    NEXT_LEAD_DYNAMIC_PRICE: 'next_slot_price/',
    OFFERS: 'offers/',
    OFFERS_VISIBILITY: 'toggle_offers_visibility/',
    OPPORTUNITIES_STATISTICS: 'opportunities/opportunities/statistics/',
    OPPORTUNITIES: 'opportunities/',
    PANEL_SUPPLIER: 'panel_supplier/',
    PARTNER_CREATE_QUOTATION: 'partner-create/',
    PENDING_QUOTATIONS_WINNERS: 'pending_feedbacks/',
    PLANS: 'plans/',
    PLANS_DESCRIPTIONS: 'plans_descriptions/',
    POSTPONE_QUOTATION: 'postpone_quotation/',
    PREORDER: 'preorders/',
    PROPOSALS: 'proposals_with_competition/',
    PURCHASED_LEADS: 'purchased_leads/',
    QUALIFIED_CONTACT_VISUALIZATION: 'qualified_contact_visualization/',
    QUOTATION_INTERNAL_OBSERVATIONS: 'quotation_internal_observations/',
    QUOTATION_SLOTS: 'check_offer_occupation/',
    QUOTATION_TEMPLATES: 'templates/',
    QUOTATION_WINNER: 'get_quotation_winner/',
    QUOTATIONS_REQUESTS: 'quotation_request/',
    RANDOM_PASSWORD_CONTRACTOR: 'random_password_contractor/',
    RECOVER_PASSWORD: 'recover_password/',
    RECYCLE_INVITES: 'resend_automatic_invites/',
    REFUSE_MEETING: 'refuse_meeting/',
    REGISTER_CLOSED_QUOTATION_NOTIFICATION: 'closed_quotation_log/',
    REGISTER_LOGIN: 'access_log/',
    REMOVE_COMPETITION: 'remove_competition/',
    REMOVE_COMPETITION_FROM_DASHBOARD: 'offers/',
    REMOVE_INVITATION: 'delete_invite/',
    REMOVE_INVITATIONS: 'delete_multiple_invitations/',
    RESEND_INVITES: 'resend_invites/',
    RESEND_MEETING_NOTIFICATION: 'resend_meeting_notification/',
    RETRIEVE_MEETING: 'get_meeting_by_quotation/',
    S3_PRESIGNED: 'generate_presigned_url/',
    SAVE_PURCHASE_ACTION_LOG: 'balance_purchases_request/',
    SEND_CONTACT_REVERSAL_REQUEST: 'request_contact_reversal/',
    SEND_CREDIT_REVERSAL_REQUEST: 'request_credit_reversal/',
    SEND_FEEDBACK: 'add_feedback/',
    SEND_MEETING_REVERSAL_REQUEST: 'request_meeting_reversal/',
    SEND_PROPOSAL: 'send_proposal/',
    SEND_QUOTATION_TO_REQUESTER: 'send_quotation_to_requester/',
    SEND_REVISION_REQUEST: 'solicit_revision/',
    SET_NEW_PASSWORD: 'set_new_password/',
    SIGNUP: 'registration/',
    SLOT_OCCUPATION_CONFIRMATION: 'slot_occupation_confirmation/',
    START_STOPWATCH: 'start/',
    STOP_STOPWATCH: 'end/',
    STOPWATCH_OBSERVATIONS: 'observations/',
    SUBGROUPS: 'sub_groups/',
    SUBGROUPS_AND_ACTIVITIES: 'sub_groups_and_activities/',
    SUBSCRIBE: 'subscribe/',
    SUBSCRIPTION: 'subscription/',
    SUBSCRIPTION_CONTACT_CREDITS: 'subscription_contact_credits/',
    SUBSCRIPTION_LAST_FEEDBACK_SEEN: 'subscription_feedback_last_seen/',
    SUBSCRIPTION_NOTIFICATION: 'subscription_purchase/',
    SUBSCRIPTION_PAYMENTS: 'subscription_payments/',
    SUPPLIER_CONTACT: 'supplier_contact/',
    SUPPLIER_CONTACT_BY_EMAIL: 'supplier_contact_email',
    SUPPLIER_FIRST_ACCESS: 'supplier/first_access/',
    SUPPLIER_LIST_COMPETITIONS: 'supplier_competitions/',
    SUPPLIER_LIST_QUOTATIONS_CATEGORIES: 'tags/',
    SUPPLIER_WITH_TOKEN: 'supplier_with_token/',
    SUPPLIERS: 'suppliers/',
    SUPPLIERS_POST_COMPETITION: 'suppliers_post_competition/',
    SURVEY_MONKEY_CREATE_RESPONSE: 'survey_response/',
    TOGGLE_INVITATIONS: 'toggle_invitations/',
    TOGGLE_PROPOSALS: 'toggle_proposals/',
    UPDATE_COMPETITION_ENDING_DATE: 'update_competition_ending_date/',
    UPDATE_COMPETITION_SLOTS: 'update_competition_vacancies/',
    UPDATE_LEAD_VALUE: 'offers/',
    UPDATE_NETWORK_CONTACTS_ADDRESS: 'update_address/',
    UPDATE_NETWORK_CONTACTS_GEOLOCATION: 'update_coordinates/',
    UPDATE_OFFERS_ORDER: 'update_offers_order/',
    UPDATE_PROPOSAL: 'proposals/',
    UPLOAD_COMPETITION_MAP: 'upload_competition_map/',
    VERIFY_CNPJ: 'find_supplier_cnpj/',
    SELECT_PAYMENT_CHECKOUT: 'profile_payment/',
    FINISH_PAYMENT: 'payment/',
    GET_STATUS_PAYMENT: '/transactions/status_payment_id_vindi/',
    CAMPAIGN: 'campaign/',
    CLICK_CAMPAIGN: 'click_compaign/',
    CAMPAIGN_INTERNAL: 'campaign_internal/',
    OFFERS_SLOT_EXTRA: 'offers_slot_extra/',
    COUNT_NOTIFICATION_UNREAD: 'count_notification_unread/',
    MARK_READ: 'mark_read/',
    MARK_ALL_READ: 'mark_all_read/',
    LEAD_CREDITS: 'lead_credits/',
    SUPPLIERS_PARTICIPATING: 'suppliers_participating/'
};

export const KEYS = {
    ACCEPETD_COOKIES: 'acpt_ck',
    ACCEPTED_PAYMENT: 'a',
    BILLET_LINK: 'k',
    CHOSEN_PLAN: 'pc',
    CLOSED_QUOTATION: 'cq',
    CNPJ: 'c',
    COMPETITION_ID: 'cid',
    COMPETITION_TOKEN: 'qt',
    CONDOTECH_PARTNER: 'ctp',
    CONTACT_ID: 'contact_id',
    CREDENTIALS_TOKEN: 'tk',
    CREDIT_USED: 'cu',
    DECLINED_PAYMENT: 'd',
    DRAFT: 'dt',
    FIRST_ACCESS: 'f',
    FREE_PREMIUM_PARTICIPATION: 'fpp',
    GOOGLE_ANALYTICS: '_ga',
    LIGHTBOX_CHECKOUT_TYPE: 'lct',
    LOGIN: 'login',
    OFFER_ID: 'o',
    PAYMENT_COMPLETED: 'p',
    PACKAGE_ID: 'p_id',
    PLAN_ID: 'plan',
    PLAN_TIER: 'i',
    PROMO_BANNER: 'pb',
    PROPOSAL_SENT: 'pst',
    QUOTATION_TOKEN: 'quotation_token',
    REDIRECT_URL: 'ru',
    RESTRICTED_ACTION: 'ra',
    SIGNUP: 'signup',
    SLOT_ID: 'slot',
    SUBSCRIPTION_ORIGIN: 'so',
    SUBSCRIPTION_PAYMENT_COMPLETED: 's',
    SUPPLIER: 'sppr',
    SUPPLIER_TYPE: 't',
    TAG: 'tag',
    TOKEN: 'tktk',
    PROPOSAL: 'prpsl'
};

export const errorCard = $(
    ` 
      <div id='errorCard' class='col s4 offset-s4 errorCard'> 
          <div class='card red darken-1'> 
              <div class='card-content white-text'> 
                  <p></p> 
              </div> 
          </div> 
      </div>`
);

export const successCard = $(
    `
      <div id='successCard' class='col s6 offset-s3 successCard'> 
          <div class='card green'> 
              <div class='card-content white-text'> 
                  <p></p> 
              </div> 
          </div> 
      </div>`
);

export const minimumPasswordLength = 8;

export const ERROR_CODES = {
    SUCCESS: 0,
    DISABLED_CONTRACTOR: 1,
    INVALID_TOKEN: 2,
    CNPJ_NOT_FOUND: 3,
    INVALID_PASSWORD: 4,
    INVALID_PASSWORD_CHANGE_REQUEST: 5,
    UNKNOWN_ERROR: 999
};

export const pageSize = 20;

export const INVITATION_STATUS = {
    EMAIL_DECLINED: 'email-declined',
    EMAIL_OPEN: 'email-open',
    EMAIL_REJECTED: 'email-rejected',
    FEEDBACK_SENT: 'feedback-sent',
    FEEDBACK_VISUALIZED: 'feedback-viewed',
    FREE_OCCUPATION: 'free-visualized',
    LEAD_VISUALIZED: 'lead-viewed',
    NOT_VISUALIZED: 'not visualized',
    PANEL_BONUS_CASH_CONSUMED: 'panel-bonus-cash-used',
    PANEL_CREDIT_CONSUMED: 'panel-credit-used',
    PANEL_LEAD_CASH_CONSUMED: 'panel-engelink-cash-used',
    PAYMENT_ACCEPTED: 'payment-accepted',
    PAYMENT_CONFIRMED: 'payment-confirmed',
    PAYMENT_PENDING: 'payment-pending',
    PAYMENT_TEST_VISUALIZED: 'payment-test-viewed',
    PAYMENT_VISUALIZED: 'payment-viewed',
    PROPOSAL_SENT: 'accepted',
    SIGNUP_COMPLETED: 'signup-completed',
    SIGNUP_VISUALIZED: 'signup-viewed',
    VISUALIZED: 'visualized'
};

export const quotationTitleLength = 40;

export const LEAD_TYPES = {
    BALANCE: 'engelink-cash-panel',
    BONUS_PANEL: 'bonus-panel',
    CONTACT_BONUS: 'bonus-contact',
    CONTACT_CREDIT_CARD: 'credit-card-contact',
    CONTACT_ENGELINK_CASH: 'engelink-cash-contact',
    CONTACT_FREE: 'free-contact',
    CONTACT_MIXED: 'mixed-contact',
    CONTACT_MIXED_FREE_BONUS: 'mixed-contact-free-bonus',
    CONTACT_MIXED_FREE_ENGELINK_CASH: 'mixed-contact-free-engelink-cash',
    CREDIT_CARD: 'credit-card',
    FREE_INVITATION: 'free-invitation',
    FREE_PANEL: 'free-panel',
    INVITATION: 'invitation',
    MEETING_BALANCE: 'engelink-cash-meeting',
    MEETING_BONUS: 'bonus-cash-meeting',
    MEETING_CREDIT_CARD: 'meeting',
    MEETING_FREE: 'free-meeting',
    PANEL: 'panel',
    PANEL_CREDIT: 'credit-panel',
    PANEL_MIXED: 'mixed-panel'
};

export const ACTIVITY_TYPE = {
    PRODUCT: 'product',
    EQUIPMENT: 'equipment',
    SERVICE: 'service'
};

export const USER_TYPE = {
    CIVIL_CONSTRUCTION: 'civil-construction',
    CONDOMINUM: 'condo',
    CORPORATIVE: 'corporative',
    PRIVATE_PERSON: 'private-person',
    PROFESSIONAL_BUILDING_MANAGER: 'professional-building-manager',
    RENOVATION_AND_SERVICES: 'renovation-and-services',
    SUPPLIER: 'supplier',
    REQUESTER: 'requester',
    CONDO_ADMINISTRATOR: 'condo-administrator'
};

export const SUBGROUP_AND_ACTIVITIES_TYPE = {
    ACTIVITY: 'activity',
    SUBGROUP: 'sub_group'
};

export const QUESTION_TYPE = {
    CHECKBOX: 'checkbox',
    RADIO: 'radio',
    TEXTAREA: 'textarea'
};

export const DOCUMENT_TYPE = {
    CNPJ: 'cnpj',
    CPF: 'cpf'
};

export const PLAN_TYPE = {
    BASIC: 'basic',
    ENTERPRISE: 'enterprise',
    LEGACY: 'legacy',
    PREMIUM: 'premium',
    PREMIUM_PLUS: 'premium_plus',
    PRO: 'pro',
    SMART: 'smart'
};

export const LIGHTBOX_CHECKOUT_TYPE = {
    BALANCE: 'balance',
    CONTACT: 'contact',
    LEAD: 'lead',
    MEETING: 'meeting',
    SUBSCRIPTION: 'subscription'
};

export const COMPETITION_OBJECTIVES = [
    { value: 1, name: 'service' },
    { value: 2, name: 'equipament' },
    { value: 3, name: 'product' },
    { value: 4, name: 'condo' }
];

export const QUOTATION_CLASSIFICATION = {
    LOW: 'low',
    MEDIUM: 'medium',
    GOOD: 'good',
    SPECIAL: 'special'
};

export const SUBSCRIPTION_ALERT = {
    PLANS: 'Planos',
    BANNER: 'Banner',
    CONTACT_NETWORK: 'Rede de contatos'
};

export const CONTROLLER_CONSTANTS = {
    CIVIL_CONSTRUCTION: 'civil-construction',
    CONDOMINUM: 'condominum',
    PRIVATE_PERSON: 'physical-person',
    PROFESSIONAL_BUILDING_MANAGER: '',
    SUPPLIER: 'supplier',
    GUEST: 'guest'
};

export const CONTACT_NETWORK_PROFILES = {
    BASIC: 'basic',
    CONTROLLER_CONSTANTS: 'civil-construction',
    CIVIL_CONSTRUCTION: 'civil-construction',
    CONDOMINIUM: 'condo',
    CORPORATIVE: 'corporative',
    PRIVATE_PERSON: 'private-person',
    PROFESSIONAL_BUILDING_MANAGER: 'professional-building-manager',
    RENOVATION_AND_SERVICES: 'renovation-and-services',
    SUPPLIER: 'supplier',
    REQUESTER: 'requester'
};

export const NETWORK_QUESTION_PROFILES = {
    BASIC: 'basic',
    CONTROLLER_CONSTANTS: 'civil-construction',
    COMPANY: 'company',
    CONDO: 'condo',
    CORPORATIVE: 'corporative',
    PRIVATE_PERSON: 'private-person',
    PROFESSIONAL_BUILDING_MANAGER: 'professional-building-manager',
    RENOVATION_AND_SERVICES: 'renovation-and-services',
    SUPPLIER: 'supplier',
    REQUESTER: 'requester'
};

export const QUOTATION_PRIORITY = {
    LOW: 'low',
    MEDIUM: 'medium',
    GOOD: 'good',
    SPECIAL: 'special'
};

export const MEETING_STATUS = {
    CONFIRMED: 'confirmed',
    PENDING: 'pending',
    REJECTED: 'rejected'
};

export const CONTACT_NETWORK_TYPE = {
    PRO_CONTACT: 'pro-contact',
    QUALIFIED_CONTACT: 'qualified-contact'
};

export const CONTACT_SOURCE = {
    CONTACT_NETWORK: 'contact-network',
    PUBLIC_CONTACT: 'public-contact',
    QUOTATION_SYSTEM: 'quotation-system'
};

export const MAIN_SERVICES = [
    {id: 1, name: 'Construção e reforma em geral'},
    {id: 2, name: 'Fachadas - pintura, restauração ou reforma'},
    {id: 3, name: 'Impermeabilização em geral'},
    {id: 4, name: 'Modernização de PC de luz'},
    {id: 5, name: 'Sistemas de energia solar - instalação ou manutenção'},
    {id: 6, name: 'Sistemas CFTV - instalação ou manutenção'},
    {id: 7, name: 'Auto de Vistoria do Corpo de Bombeiros (AVCB)'},
    {id: 8, name: 'Autovistoria Predial'},
    {id: 9, name: 'Terceirização de portaria'},
    {id: 10, name: 'Terceirização de limpeza'}
]

export const MAIN_TAGS_SUPPLIERS = [
    {id: 40, name: 'Obras e reformas'},
    {id: 131, name: 'Recuperação de fachada'},
    {id: 40, name: 'Impermeabilização'},
    {id: 119, name: 'Instalações elétricas'},
    {id: 116, name: 'Energia solar'},
    {id: 69, name: 'Prevenção e combate à Incêndios'},
    {id: 80, name: 'Terceirização de Serviços'},
    {id: 138, name: 'Sistemas de segurança, cftv e acesso'},
    {id: 120, name: 'Laudos e vistorias'},
    {id: 162, name: 'Ar Condicionado, aquecedores e exaustores'}
]

export const TERMS_OF_USE = 'https://static.app.engelink.com.br/termos-de-uso.pdf';
